<template>
  <header class="battle-header">
    <button class="battle-back" type="button" aria-label="返回" @click="$emit('back')">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M15 4.5 7.5 12l7.5 7.5" />
      </svg>
    </button>
    <h1 class="battle-title">{{ title }}</h1>
    <span class="battle-header-spacer" aria-hidden="true"></span>
  </header>
</template>

<script>
export default {
  name: 'BattleHeader',
  props: {
    title: { type: String, required: true }
  },
  emits: ['back']
}
</script>

<style scoped>
.battle-header {
  position: fixed;
  z-index: 100;
  inset: 0 0 auto;
  height: var(--battle-header-height);
  padding-top: var(--battle-safe-top);
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) 56px;
  align-items: center;
  background: #2d2d2d url('@/assets/top.png') no-repeat center center;
  background-size: cover;
  color: #fff;
}

.battle-back {
  width: 56px;
  height: 56px;
  padding: 15px;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.battle-back svg {
  width: 26px;
  height: 26px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.battle-title {
  margin: 0;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  line-height: 56px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.battle-header-spacer { width: 56px; }
</style>
